import { baseClient } from "./baseRequest";

export type CrashBundle = {
  fileKey: string;
  clockId: string;
  timestamp: number;
  fileName: string;
  sizeBytes: number;
  createdAt: string;
};

export type AnalysisModel = {
  id: string;
  label: string;
  provider: "openai" | "anthropic";
};

export type CrashBundlesClient = {
  getLatest(): Promise<CrashBundle[]>;
  searchByClockId(clockId: string): Promise<CrashBundle[]>;
  getAnalysisModels(): Promise<AnalysisModel[]>;
  requestBundle(clockId: string): Promise<{ dispatched: boolean }>;
  runAnalysis(fileKey: string, model: string): Promise<{ dispatched: boolean }>;
  getDownloadUrl(fileKey: string): Promise<{ url: string }>;
};

const crashBundlesClient: CrashBundlesClient = {
  getLatest() {
    return baseClient.get<CrashBundle[]>({
      url: "/admin/clocks/crash-bundles/latest",
    });
  },
  searchByClockId(clockId: string) {
    return baseClient.get<CrashBundle[]>({
      url: "/admin/clocks/crash-bundles/search",
      params: { clockId },
    });
  },
  getAnalysisModels() {
    return baseClient.get<AnalysisModel[]>({
      url: "/admin/clocks/crash-bundles/models",
    });
  },
  requestBundle(clockId: string) {
    return baseClient.post<{ dispatched: boolean }>({
      url: "/admin/clocks/crash-bundles/request",
      body: { clockId },
    });
  },
  runAnalysis(fileKey: string, model: string) {
    return baseClient.post<{ dispatched: boolean }>({
      url: "/admin/clocks/crash-bundles/analyze",
      body: { fileKey, model },
    });
  },
  getDownloadUrl(fileKey: string) {
    return baseClient.get<{ url: string }>({
      url: "/admin/clocks/crash-bundles/download-url",
      params: { fileKey },
    });
  },
};

export default crashBundlesClient;
